import { Nullable } from '@jack-henry/frontend-utils/types';
import { WireFileModelDto } from '@treasury/api/channel';

export const nullWireFile: Nullable<WireFileModelDto> = {
    id: 0,
    updatedDate: '',
    wireFileId: 0,
    fileName: '',
    fileSize: 0,
    uploadedBy: '',
    uploadDate: '',
    amount: 0,
    totalWireCount: 0,
    batchCount: 0,
    approvedCount: 0,
    pendingCount: 0,
    rejectedCount: 0,
    expiredCount: 0,
    isValid: false,
    isExpired: false,
    isConfirmed: false,
    wireFileUniqueId: '',
    processedBy: '',
    processedDate: '',
    contentData: '',
    fileFormat: '',
    isDuplicated: false,
    duplicatedWireFileUniqueId: '',
};
